/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  RESUBMIT_APPLICATION_BY_APPLICANT_SUCCESS: {
    message: 'Application resubmitted successfully',
  },
  RESUBMIT_APPLICATION_BY_APPLICANT_ERROR: {
    message: 'Failed to resubmit application',
  },
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.jamaica.newApplication',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        MUTATE: { target: 'INITIATE_RESUBMIT_APPLICATION_BY_APPLICANT' },
      },
    },
    INITIATE_RESUBMIT_APPLICATION_BY_APPLICANT: {
      invoke: {
        id: 'ResubmitApplicant',
        src: 'ResubmitApplicant',
        onDone: {
          target: 'RESUBMIT_APPLICATION_BY_APPLICANT_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'RESUBMIT_APPLICATION_BY_APPLICANT_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    RESUBMIT_APPLICATION_BY_APPLICANT_SUCCESS: {
      //type: "final",
      on: {
        MUTATE: { target: 'INITIATE_RESUBMIT_APPLICATION_BY_APPLICANT' },
      },
    },
    RESUBMIT_APPLICATION_BY_APPLICANT_ERROR: {
      //type: "final",
      on: {
        MUTATE: { target: 'INITIATE_RESUBMIT_APPLICATION_BY_APPLICANT' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
